import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Label } from 'reactstrap';
import { Row, Col, Form, Input, InputNumber, Radio } from 'antd';

import Brand from '../CarSelector/brand';
import Model from '../CarSelector/model';
import Version from '../CarSelector/version';

import configs from 'configs';

import messages from './messages';

import 'antComponentsStyle';
import './fields.scss';

class OfferFields extends React.Component {
  constructor(props) {
    super(props);
  }

  fieldIsInvalid = fieldName =>
    this.props.errors.some(error => error === fieldName);

  showDynamicSelectors = () => this.props.values.vehicleType === 'car';

  inputNumberCallback = (name, value) => this.props.callback({target: {name, value}})

  render() {
    const {
      values,
      callback,
      brands,
      models,
      versions,
      isLoading,
    } = this.props;

    return (
      <div className={'OfferFields'}>
        {configs.veichleTypes && configs.veichleTypes.length > 1 ?
          <Row gutter={16}>
            <Col xl={24}>
              <Label className="required d-block">
                <FormattedMessage {...messages.vehicleTypeLabel} />
              </Label>
              <Form.Item>
                <Radio.Group onChange={callback} name="vehicleType" value={values.vehicleType}>
                  {configs.veichleTypes.map(veichleType =>
                    <Radio value={veichleType.value} key={veichleType.key}>
                      <FormattedMessage {...messages[veichleType.key]} />
                    </Radio>
                  )}
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          : null
        }
        <Row gutter={16}>
          <Col xl={4} md={8} sm={12} xs={24}>
            <Form.Item
              required
              validateStatus={this.fieldIsInvalid('brand') ? 'error' : null}
            >
              <Label for="brand" className="required">
                <FormattedMessage {...messages.brand} />
              </Label>
              {this.showDynamicSelectors() ? (
                <Brand brands={brands} />
              ) : (
                <Input
                  type="text"
                  name="brand"
                  id="brand"
                  placeholder="Marca"
                  value={values.brand}
                  onChange={callback}
                  required
                />
              )}
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={12} xs={24}>
            <Form.Item
              required
              validateStatus={this.fieldIsInvalid('model') ? 'error' : null}
            >
              <Label for="model" className="required">
                <FormattedMessage {...messages.model} />
              </Label>
              {this.showDynamicSelectors() ? (
                <Model models={models} isLoading={isLoading} />
              ) : (
                <Input
                  type="text"
                  name="model"
                  id="model"
                  placeholder="Modello"
                  value={values.model}
                  onChange={callback}
                  required
                />
              )}
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={12} xs={24}>
            <Form.Item
              required
              validateStatus={this.fieldIsInvalid('version') ? 'error' : null}
            >
              <Label for="version" className="required">
                <FormattedMessage {...messages.version} />
              </Label>
              {this.showDynamicSelectors() ? (
                <Version versions={versions} isLoading={isLoading} />
              ) : (
                <Input
                  type="text"
                  name="version"
                  id="version"
                  placeholder="Allestimento"
                  value={values.version}
                  onChange={callback}
                  required
                />
              )}
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={12} xs={24}>
            <Form.Item
              required
              validateStatus={this.fieldIsInvalid('duration') ? 'error' : null}
            >
              <Label for="duration" className="required">
                <FormattedMessage {...messages.duration} />
              </Label>
              <InputNumber
                name="duration"
                id="duration"
                placeholder={'36'}
                value={values.duration}
                onChange={value => this.inputNumberCallback('duration', value)}
                className="w-100"
                required
              />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={12} xs={24}>
            <Form.Item
              required
              validateStatus={this.fieldIsInvalid('distance') ? 'error' : null}
            >
              <Label for="distance" className="required">
                <FormattedMessage {...messages.distance} />
              </Label>
              <InputNumber
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                }
                parser={value => value.replace(/\.*/g, '')}
                name="distance"
                id="distance"
                placeholder={'10000'}
                value={values.distance}
                onChange={value => this.inputNumberCallback('distance', value)}
                className="w-100"
                required
              />
            </Form.Item>
          </Col>
          <Col xl={4} md={8} sm={12} xs={24}>
            <Form.Item
              required
              validateStatus={this.fieldIsInvalid('deposit') ? 'error' : null}
            >
              <Label for="deposit" className="required">
                <FormattedMessage {...messages.deposit} />
              </Label>
              <InputNumber
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                }
                parser={value => value.replace(/\.*/g, '')}
                name="deposit"
                id="deposit"
                placeholder={'2000'}
                value={values.deposit}
                onChange={value => this.inputNumberCallback('deposit', value)}
                className="w-100"
                required
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col xl={12} sm={24}>
            <Label for="services">
              <FormattedMessage {...messages.services} />
            </Label>
            <Input.TextArea
              name="services"
              rows={2}
              id="services"
              placeholder={'Cambio gomme'}
              value={values.services}
              onChange={callback}
            />
          </Col>
          <Col xl={12} sm={24}>
            <Label for="notes">
              <FormattedMessage {...messages.notes} />
            </Label>
            <Input.TextArea
              name="notes"
              rows={2}
              id="notes"
              placeholder={'...'}
              value={values.notes}
              onChange={callback}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

OfferFields.defaultProps = {};

OfferFields.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.any.isRequired,
  callback: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
export default OfferFields;
